import React, {useState} from "react";
import {useStore} from "hooks/useStore";
import {useTranslation} from "react-i18next";
import {LeftButton} from "components/order/orderDetail/orderDetailStyles";
import {TextBoxFormModal} from "../../_defaultComponents/TextBoxFormModal/TextBoxFormModal";

const SplitOrderButton = ({deliveryId, delivery, orders, deliveryType, onSplitComplete}) => {
    const stores = useStore();
    const {t} = useTranslation(["orderDetail", "common"]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState("");
    const [modalData, setModalData] = useState({deliveryId: ""});

    const orderSteps = orders.map(order => ({stepInfo: order}));
    const deliveryData = {delivery: {...delivery}};
    const splitOrder = async ({
        deliveryId,
        orderIds,
        allowMerge,
        forceCourierId,
        reason,
        triggerInMinutes
    }) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("modal.splitOrder.content", {ns: "orderDetail"}),
            onOk: async () => {
                await stores.orderStore.splitOrder({
                    deliveryId,
                    orderIds,
                    allowMerge,
                    forceCourierId,
                    reason,
                    triggerInMinutes
                });
                setModalVisible(false);
                if (onSplitComplete) onSplitComplete();
            }
        });
    };
    return (
        <>
            <LeftButton
                data-testid="splitButton"
                type="primary"
                style={{
                    minWidth: "120px",
                    padding: "4px 8px",
                    height: "32px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    backgroundColor: "#AEF001",
                    border: "none",
                    color: "#000"
                }}
                onClick={() => {
                    setModalVisible(true);
                    setModalType("splitOrder");
                    setModalData({deliveryId, orderSteps});
                }}
            >
                {t("actions.splitOrder", {ns: "orderDetail"})}
            </LeftButton>

            <TextBoxFormModal
                isVisible={modalVisible}
                setVisible={setModalVisible}
                okFunction={splitOrder}
                label={t("modal.splitOrder.label", {ns: "orderDetail"})}
                title={t("modal.splitOrder.title", {ns: "orderDetail"})}
                modalType={modalType}
                modalData={modalData}
                deliveryId={deliveryId}
                deliveryData={deliveryData}
                allowMergeDefault
                reasonOptions={{
                    defaultValue: "cancelDueToCompany"
                }}
                cancelFn={() => setModalType("")}
                deliveryType={deliveryType}
                allPoolCouriers={true}
            />
        </>
    );
};

export default SplitOrderButton;
